<div class="file-upload-modal">
  <!-- File picker -->
  <label class="upload-dropzone" [class.disabled]="uploading" [class.dragging]="dragging"
         (dragover)="onDragOver($event)" (dragleave)="dragging = false" (drop)="onDrop($event)">
    <input
      type="file"
      [accept]="data?.accept || '*'"
      [multiple]="data?.multiple !== false"
      [disabled]="uploading"
      (change)="onSelect($event)"
    />
    <i class="pi pi-upload"></i>
    <span class="text-900 font-medium">Click to choose file{{ data?.multiple !== false ? 's' : '' }}, drop {{ data?.multiple !== false ? 'them' : 'it' }} here, or paste ({{ pasteKeys }})</span>
    <span class="text-600 text-sm">{{ typesLabel ? typesLabel + ', max ' : 'Max ' }}{{ maxSizeLabel }} per file{{ linkCap }}</span>
  </label>
  <small *ngIf="pasteHint" class="paste-hint">{{ pasteHint }}</small>

  <!-- From a link (2026-11-03, every caller): the server fetches it (a file, or a page's images to pick). -->
  <div *ngIf="data && !data.noLink" class="link-box">
    <div class="flex gap-2">
      <input pInputText type="url" class="flex-1 min-w-0 link-url" [(ngModel)]="linkUrl" [placeholder]="linkPlaceholder"
             [disabled]="uploading || linkBusy" (keydown.enter)="fetchLink()" />
      <button pButton type="button" class="p-button-outlined link-fetch" icon="pi pi-link" label="From a link" (click)="fetchLink()" [disabled]="!linkUrl.trim() || uploading" [loading]="linkBusy"></button>
    </div>
    <small *ngIf="linkError" class="file-error link-error">{{ linkError }}</small>
    <div *ngIf="linkImages as imgs" class="link-images">
      <small class="text-600">The page's images: pick one.</small>
      <div class="link-grid">
        <button *ngFor="let src of imgs" type="button" class="link-pick" (click)="fetchLink(src)" [disabled]="linkBusy" [attr.title]="src">
          <img [src]="src" alt="" referrerpolicy="no-referrer" />
        </button>
      </div>
    </div>
  </div>

  <!-- Queue -->
  <ul class="file-queue" *ngIf="queue.length">
    <li *ngFor="let f of queue; let i = index" class="file-row" [class.has-error]="f.error">
      <i class="pi" [ngClass]="f.type?.startsWith('image/') ? 'pi-image' : 'pi-file'"></i>
      <div class="file-meta">
        <span class="file-name">{{ f.name }}</span>
        <small *ngIf="f.error" class="file-error">{{ f.error }}</small>
        <p-progressBar
          *ngIf="uploading && !f.error"
          [value]="f.percent"
          [showValue]="true"
          styleClass="upload-progress"
        ></p-progressBar>
      </div>
      <button
        *ngIf="!uploading"
        pButton
        type="button"
        icon="pi pi-times"
        class="p-button-text p-button-rounded p-button-sm"
        (click)="removeAt(i)"
      ></button>
    </li>
  </ul>

  <!-- Actions -->
  <div class="upload-actions">
    <button
      pButton
      type="button"
      label="Cancel"
      class="p-button-text"
      [disabled]="uploading"
      (click)="cancel()"
    ></button>
    <button
      pButton
      type="button"
      [label]="uploading ? 'Uploading…' : 'Upload'"
      icon="pi pi-upload"
      [disabled]="!canUpload"
      [loading]="uploading"
      (click)="upload()"
    ></button>
  </div>
</div>
